import "./bootstrap"

import { createApp } from "vue"
import { createRouter, createWebHistory } from "vue-router"
import ClientAuthApp from "./ClientAuthApp.vue"
import Auth from "./screens/PortalTokenAuth.vue"
import Login from "./screens/PortalEmailLogin.vue"
import PortalMfaAuth from "./screens/PortalMfaAuth.vue"
import VendorW9Upload from "./screens/VendorW9Upload.vue"
import * as Sentry from "@sentry/vue"
import sentryBeforeSend from "../../js/helpers/sentryBeforeSend"
import { VueQueryPlugin } from "@tanstack/vue-query"
import PortalAlert from "../plugins/PortalAlert.js"

const routes = [
  { path: "/client-portal/login", component: Login },
  { path: "/cp/:uri", component: Login },
  { path: "/client-portal/mfa", component: PortalMfaAuth },
  { path: "/client-portal/:id/verify", component: Auth },
  { path: "/vendor-portal/w9-request/:vendor_request", component: VendorW9Upload },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

// Mount the app
const app = createApp(ClientAuthApp)

Sentry.init({
  app,
  dsn: window.keys.sentry_dsn,
  environment: window.FinancialCents?.env,
  sendDefaultPii: true,
  // This enables automatic instrumentation (highly recommended),
  // but is not necessary for purely manual usage
  integrations: [Sentry.browserTracingIntegration()],

  //Update tracesSampleRate to 0.1 for production
  tracesSampleRate: window.keys.sentry_sample_rate,

  tracePropagationTargets: window.keys.sentry_propagation ? window.keys.sentry_propagation.split(",") : [],
  beforeSend: sentryBeforeSend,
})

async function enableMocking() {
  if (import.meta.env.VITE_ENABLE_MSW === "true") {
    const { worker } = await import("../mocks/browser")

    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start()
  }
}

app.use(router)
app.use(VueQueryPlugin)
app.use(PortalAlert)

enableMocking().then(() => {
  app.mount("#app")
})
